import { useMemo } from 'react';
import { Transition } from 'framer-motion';
import { containerVariants, productVariants } from '../../animations/productAnimations';
import { subFilterVariants } from '../../animations/categoryFilterAnimations';

export interface AnimationConfig {
  containerVariants: typeof containerVariants;
  productVariants: typeof productVariants;
  subFilterVariants: typeof subFilterVariants;
  productGridTransition: Transition;
}

export const useAnimationConfig = (): AnimationConfig => {
  const animationConfig = useMemo(
    () => ({
      containerVariants,
      productVariants,
      subFilterVariants,
      productGridTransition: {
        layout: {
          duration: 0.32,
          ease: 'easeInOut' as const,
        },
      } as Transition,
    }),
    []
  );

  return animationConfig;
};
